// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UCaK6zBzXskkgWZA97g7{justify-content:space-between;align-self:stretch;align-items:flex-start;padding:0 24px;display:flex}.UCaK6zBzXskkgWZA97g7 .KBTsmbXddNw3yi3xmayK{flex-direction:column;gap:4px;padding:16px 24px 16px 0;display:flex}.UCaK6zBzXskkgWZA97g7 .DOeA8IQYI_g6c_EHJceY{padding:14px 0 0 20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `UCaK6zBzXskkgWZA97g7`,
	"left": `KBTsmbXddNw3yi3xmayK`,
	"right": `DOeA8IQYI_g6c_EHJceY`
};
export default ___CSS_LOADER_EXPORT___;
